const disclaimer = {
  outLink: "https://webcms.pima.gov/government/flood_control/",
  body: (
    <>
      <p style={{ padding: "2rem" }}>
        The Pima County Regional Flood Control District makes no warranty,
        expressed nor implied, regarding the accuracy of the data provided.
      </p>
      <p style={{ padding: "2rem" }}>
        ALERT System data come from remote automated sensors. These data are
        being supplied for general information only. The user agrees to comply
        with the Limitation of Use and Assumption of Risk terms as stated in{" "}
        <a href="https://www.pima.gov/1472/Disclaimer">full disclaimer</a>.
      </p>
    </>
  ),
};

export default disclaimer;
